import styled, { css } from 'styled-components'
import { ReactComponent as ChevronLeft } from '../../../../../assets/icons/chevron-left-icon.svg'
import { ReactComponent as ChevronRight } from '../../../../../assets/icons/chevron-right.svg'

export const Container = styled.div`
  margin: 3rem auto 0;
  display: flex;
  gap: 1rem;
  justify-content: center;
`

export const PaginationItem = styled.li`
  list-style: none;
  font-family: 'Open sans';
  cursor: pointer;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  font-weight: 600;
  color: #555555;
  ${({ outline }) => outline && css`
    background-color: #D8EEF6;
    color: #028BB7;
    border-radius: 50%;
  `}
`
const chevronColor = css`
  path {
    fill: ${({ disabled }) => (disabled ? '#F2F2F2' : '#028BB7')};
  }
`
export const ChevronLeftIcon = styled(ChevronLeft)`
  ${chevronColor}
`
export const ChevronRightIcon = styled(ChevronRight)`
  ${chevronColor}
`
